module.exports = __webpack_public_path__ + "pc/img/rec_20.a788bb4a.svg";